import { CrewMemberExt } from '@bechtel/client-common';
import { PersonaType } from '@bechtel/types';
import { MockForemanId, MockGeneralForemanId, MockSuperintendentId } from './types';
//@ts-ignore needed for declaration generation
import ProfilePhoto from '@bechtel/client-assets/dist/images/profile-photo.svg';
import { t } from '@lingui/macro';
export const MockCrewMembers: CrewMemberExt[] = [
  {
    id: MockSuperintendentId,
    firstName: t`Please Select`,
    lastName: '',
    persona: PersonaType.SUPERINTENDENT,
    imageUrl: ProfilePhoto,
    title: t`None Selected`,
  },
  {
    id: MockGeneralForemanId,
    firstName: t`General Foreman`,
    lastName: '',
    persona: PersonaType.GENERAL_FOREMAN,
    imageUrl: ProfilePhoto,
    title: t`None Selected`,
  },
  {
    id: MockForemanId,
    firstName: t`Foreman`,
    lastName: '',
    persona: PersonaType.FOREMAN,
    imageUrl: ProfilePhoto,
    title: t`None Selected`,
  },
];
